import { render, staticRenderFns } from "./linkTd.vue?vue&type=template&id=baf4317e&"
import script from "./linkTd.vue?vue&type=script&lang=js&"
export * from "./linkTd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports